// extracted by mini-css-extract-plugin
module.exports = {"prose":"style_prose__woZCM","isPage":"style_isPage___Eunt","small":"style_small__trzcj"};